import { GanttTask, ComputedTask } from '../types/types';
import { ROW_H, BAR_PAD } from '../constants';
import '../Gantt.css';

interface BarProps {
  task: GanttTask;
  c: ComputedTask;
  dayWidth: number;
  x: number;
  y: number;
  sel: boolean;
  summary: boolean;
  color: string;
  onSelect: () => void;
}

export default function Bar({ task, c, dayWidth, x, y, sel, summary, color, onSelect }: BarProps) {
  const top = y + BAR_PAD;
  const h = ROW_H - BAR_PAD * 2;
  const SUMMARY_H = 6;                          // thin plan/summary line
  const sumTop = y + (ROW_H - SUMMARY_H) / 2;

  if (c.kind === 'milestone') {
    const s = h;
    const cx = x;
    const cy = y + ROW_H / 2;
    return (
      <>
        <div
          onClick={onSelect}
          title={task.name}
          style={{
            position: 'absolute',
            left: cx - s / 2,
            top: cy - s / 2,
            width: s,
            height: s,
            background: '#9c27b0',
            transform: 'rotate(45deg)',
            borderRadius: 3,
            cursor: 'pointer',
            boxShadow: sel ? '0 0 0 2px #fff,0 0 0 4px #9c27b0' : 'none',
          }}
        />
        <div
          style={{
            background: color,
            transform: 'rotate(45deg)',
            borderRadius: 3,
            cursor: 'pointer',
            boxShadow: sel ? `0 0 0 2px #fff,0 0 0 4px ${color}` : 'none',
          }}
        >
          {task.name}
        </div>
      </>
    );
  }

  const w = Math.max(c.duration * dayWidth, 12);

if (summary) {
  return (
    <div className="ganttSummary" onClick={onSelect} style={{ left: x, top: sumTop, width: w, height: SUMMARY_H, cursor: 'pointer', pointerEvents: 'auto' }}>
      <span className="ganttSummaryLabel">{task.name}</span>
      <div className="ganttSummaryTrack" style={{ borderRadius: SUMMARY_H / 2 }} />
      <div className="ganttSummaryCap left" />
      <div className="ganttSummaryCap right" />
    </div>
  );
}

 return (
  <div style={{ position: 'absolute', left: x, top, width: w, height: h }}>
    <div
      onClick={onSelect}
      className="bar"
      style={{ background: color, cursor: 'pointer' }}
    >
      <span className="barLabel" style={{ lineHeight: `${h}px` }}>
        {task.name}
      </span>
    </div>
  </div>
);
}
